import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { InternationalizationService } from '@core/internationalization/internationalization.service';
import { ResetAppStateService } from '@core/services/reset-app-state.service';
import { AuthService } from '@features/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from '@shared/services/toast.service';
import { catchError, throwError } from 'rxjs';

const getSlug = () => {
    const url = window.location.href;
    const urlArr = url.split('/');
    return urlArr[urlArr.length - 1];
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const toast = inject(ToastService);
    const cookie = inject(CookieService);
    const authS = inject(AuthService);
    const i18nS = inject(InternationalizationService);

    const token = authS.token() || cookie.get('auth.token');
    // Product language, not the browser's: server-side texts generated in the
    // scope of this request (e.g. push notifications) should follow the UI.
    const headers: Record<string, string> = { 'Accept-Language': i18nS.getLanguage() };
    if (token) headers['authorization'] = `Bearer ${token}`;

    const request = req.clone({ withCredentials: true, setHeaders: headers });

    return next(request).pipe(
        catchError((err: HttpErrorResponse) => {
            const slug = getSlug();

            switch (err.status) {
                case 0:
                    toast.error('twinnyx.toast.network');
                    break;
                case 401:
                    // TwinnyX's sign-up handles it on screen (back to its email step)
                    if (window.location.pathname.endsWith('/auth/start')) break;
                    if (slug !== 'login') {
                        toast.error(
                            'twinnyx.toast.sessionExpired.message',
                            'twinnyx.toast.sessionExpired.title'
                        );
                    }
                    authS.logout();
                    break;
            }

            return throwError(() => err);
        })
    );
};
